/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/

/** @packageDocumentation
 * @module Utilities
 */

/** Interface that returns indices of matches
 * @internal
 */
export interface IMatch {
  start: number;
  end: number;
}
